/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface OrgBlockResponse {
  /** Тип блокировки */
  blockType?: string;

  /**
   * Дата блокировки
   * @format date-time
   */
  blockDate?: string;
}

export interface OrgBlocksResponse {
  orgBlocks?: OrgBlockResponse[];
}

export interface ValidationErrorInfo {
  /**
   * Дата и время генерации ошибки
   * @format date-time
   */
  timestamp: string;

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /** Код ошибки */
  errorCode:
    | "VALIDATION_ERROR"
    | "INVALID_PARAMETER"
    | "NO_RESPONSE_IN_ACCEPTABLE_TIME"
    | "NOT_FOUND"
    | "INTEGRATION_EXCEPTION"
    | "WRONG_CONFIRM_TYPE"
    | "INTERNAL_SERVER_ERROR"
    | "INVALID_TOKEN"
    | "CLIENT_ALREADY_HAS_BLOCK_WITH_SAME_TYPE"
    | "CLIENT_HAS_OPEN_CONTRACT";

  /** Развернутое описание ошибки/ок */
  errorDetails: Record<string, ValidationFieldInfo[]>;
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;

  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;
}

export interface ErrorInfo {
  /**
   * Сообщение об ошибке
   * @example Ошибка обработки объекта
   */
  message: string;

  /** Код ошибки */
  errorCode:
    | "VALIDATION_ERROR"
    | "INVALID_PARAMETER"
    | "NO_RESPONSE_IN_ACCEPTABLE_TIME"
    | "NOT_FOUND"
    | "INTEGRATION_EXCEPTION"
    | "WRONG_CONFIRM_TYPE"
    | "INTERNAL_SERVER_ERROR"
    | "INVALID_TOKEN"
    | "CLIENT_ALREADY_HAS_BLOCK_WITH_SAME_TYPE"
    | "CLIENT_HAS_OPEN_CONTRACT";
}

export interface DelegateInfo {
  /**
   * Идентификатор уполномоченного лица
   * @format uuid
   */
  id: string;

  /** ФИО уполномоченного лица */
  fullName: string;

  /** Признак, что делегат является ЕИО (единоличный исполнительный орган) */
  eio: boolean;

  /** Тип подписи */
  authoritySignature?: string;

  /** Список доступных способов подтверждений */
  confirmTypes?: string[];

  /** Телефон уполномоченного лица */
  phone?: string;

  /** Короткое наименование организации */
  orgName: string;

  /** ИНН организации */
  inn: string;

  /** Email уполномоченного лица */
  email?: string;

  /** Идентификатор клиента (организации) в ЦФТ */
  orgAbsId: string;

  /** Код филиала клиента (организации) */
  orgBranchCode: string;

  /** ОГРН Клиента */
  ogrn: string;

  /** Тип клиента с точки зрения ЛОРО банка */
  clientGroup?: string;

  /**
   * Схема подписи (количество подписей) организации
   * @format int32
   */
  orgSignCount: number;

  /** Список ролей и бизнес операций для делегата */
  permissions?: Permission[];
}

/**
 * Список ролей и бизнес операций для делегата
 */
export interface Permission {
  /** Сигнатура роли */
  roleSignature?: string;

  /** Список бизнес операций доступных для роли */
  businessOperationSignatures?: string[];
}

import { HttpClient } from "../../client";
import { RequestParams } from "../../client/types";

/**
 * @title МС Клиентский профиль
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://ms-org-registry.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Блокировки организации
     * @name GetOrgBlocks
     * @summary Получение информации по блокировкам организации
     * @request GET:/api/org-registry/external/v1/org-block
     * @secure
     */
    getOrgBlocks: (params: RequestParams = {}) =>
      this.request<OrgBlocksResponse, void | OrgBlocksResponse>({
        path: `/api/org-registry/external/v1/org-block`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Внешние api для сотрудников клиента
     * @name GetDelegateInfo
     * @summary Получение информации по делегату
     * @request GET:/api/org-registry/external/v1/delegate-info
     * @secure
     */
    getDelegateInfo: (params: RequestParams = {}) =>
      this.request<DelegateInfo, ValidationErrorInfo | void | ErrorInfo>({
        path: `/api/org-registry/external/v1/delegate-info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
